export default "__VITE_ASSET__94910c8b__"